import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';


// Icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import { Auth, Services } from "baseparking-api";
import CreateService from './CreateService';

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    },
    float: 'right'
  },
  addService: {
    float: 'right'
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  }
};

class ServicesView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      services: [],
      inActiveServices: [],
      serviceDialog: false,
      editingService: {}
    }
  }

  componentWillMount() {
    this.refreshData();
  }

  refreshData = () => {
    Auth.authenticate('dagurleo@gmail.com', 'smegma123')
      .then(res => {
        Services.getAll()
          .then(res => {
            const services = res.data.services.sort((a, b) => a.label.localeCompare(b.label));
            this.setState({
              services: services.filter(s => s.active),
              inActiveServices: services.filter(s => !s.active),
              serviceDialog: false,
              editingService: {},
            })
          })
          .catch(console.error)
        Auth.isAuthenticated();
      })
  }

  closeCreationForm = () => this.setState({ editingService: {}, serviceDialog: false });

  editingService = editingService => {
    this.setState({ editingService, serviceDialog: true });
  }

  deactivateService = service => {
    Services.deactivate(service)
      .then(res => {
        this.refreshData();
      })
      .catch(console.error);
  };

  activateService = service => {
    Services.activate(service)
      .then(res => {
        this.refreshData();
      })
      .catch(console.error);
  };

  deleteService = service => console.log('deleting service');

  render() {
    const { classes } = this.props;
    const { services, inActiveServices } = this.state;
    // 
    const activeButtons = service => [
      { color: "danger", icon: Close, label: 'Óvirkja þjónustu', function: this.deactivateService },
      { color: "warning", icon: Edit, label: 'Breyta þjónustu', function: this.editingService },
    ].map((prop, key) => {
      return (
        <Tooltip title={prop.label}>
          <Button color={prop.color} className={classes.actionButton} key={key} onClick={e => prop.function(service)}>
            <prop.icon className={classes.icon} />
          </Button>
        </Tooltip>
      );
    });

    const inActiveButtons = service => [
      { color: "danger", icon: Close, label: 'Eyða þjónustu varanlega', function: this.deleteService },
      { color: "warning", icon: Edit, label: 'Breyta þjónustu', function: this.editingService },
      { color: "success", icon: Add, label: 'Virkja þjónustu', function: this.activateService },
    ].map((prop, key) => {
      return (
        <Tooltip title={prop.label}>
          <Button color={prop.color} className={classes.actionButton} key={key} onClick={e => prop.function(service)}>
            <prop.icon className={classes.icon} />
          </Button>
        </Tooltip>
      );
    });

    // Formatting services list
    let serviceList = [];
    let serviceHeader = [];

    if (services.length) {
      services.map(s => {
        console.log(s);
        let list = [s.label, s.price, s.sizeSpecific];
        list.push(activeButtons(s));
        // let list = Object.values(s).slice(1);
        // list.splice(2, 1);
        if (s.daily) {
          list[1] += ' á dag';
        }
        if (list[2] === null) list[2] = 'allar'
        serviceList.push(list);
      })
      serviceHeader = ['Nafn', 'Verð', 'Stærð', '']
    }

    let inActiveServiceList = [];
    let inActiveServiceHeader = [];
    if (inActiveServices.length) {
      inActiveServices.map(s => {
        let list = [s.label, s.price, s.sizeSpecific];
        list.push(inActiveButtons(s));
        if (s.daily) {
          list[1] += ' á dag';
        }
        if (list[2] === null) list[2] = 'allar'
        inActiveServiceList.push(list);
      })
      inActiveServiceHeader = ['Nafn', 'Verð', 'Stærð', '']
    }

    return (
      <GridContainer>
        {
          this.state.serviceDialog &&
          <CreateService
            open={this.state.serviceDialog}
            onClose={this.closeCreationForm.bind(this)}
            onComplete={this.refreshData.bind(this)}
            service={this.state.editingService || null}
          />
        }
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success" className={classes.flex}>
              <div>
                <h4 className={classes.cardTitleWhite}>Virkar Þjónustur</h4>
                <p className={classes.cardCategoryWhite}>Allar þær þjónustur sem Smart Parking hefur uppá að bjóða</p>
              </div>
              <Button color="success" className={classes.addService} onClick={e => this.setState({ serviceDialog: true })}>Bæta við Þjónustu</Button>
            </CardHeader>
            {
              serviceList &&
              <CardBody>
                <Table
                  tableHeaderColor="primary"
                  tableHead={serviceHeader}
                  tableData={serviceList}
                />
              </CardBody>
            }
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card plain>
            <CardHeader plain color="danger">
              <h4 className={classes.cardTitleWhite}>
                Óvirkar þjónustur
            </h4>
              <p className={classes.cardCategoryWhite}>
                Þjónustur sem ekki lengur eru virkar
            </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="primary"
                tableHead={inActiveServiceHeader}
                tableData={inActiveServiceList}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ServicesView);


// WEBPACK FOOTER //
// ./src/views/Services/Services.jsx